<template>
  <div class="relative flex items-center px-6 !h-32 text-[#707C8E]">
    <!-- <div class="relative p-6 text-[#707C8E]" :class="{ '!py-12 2xl:!py-[2.83rem]': noEmissionIntensity }"> -->
    <div
      v-if="typeof intensity === 'number' && companyCurrency"
      class="font-normal"
    >
      <h3 class="text-base font-medium 2xl:text-lg">
        GHG Emission Intensity
      </h3>
      <div class="mt-2 no-localize-translate">
        <h4 class="font-normal text-slate-900 text-lg lg:text-3xl flex items-baseline gap-2">
          {{ emissionsIntensity }}
          <span class="text-xs lg:text-sm mt-1 text-[#707C8ECC] no-localize-translate">tCO<sub>2</sub>e per {{ companyCurrency }}</span>
        </h4>
      </div>
      <div class="mt-0.5 whitespace-nowrap text-xs 2xl:text-sm">
        <div
          v-if="previousYearIntensityChange !== null"
          class="text-[10px] lg:text-[12px]"
        >
          <span
            class="border-transparent rounded-md px-1 py-0.5"
            :class="[previousYearIntensityChange > 0 ? 'text-[#E95844] bg-[#E95844]/[.08]' : 'text-[#038153] bg-[#038153]/[.08]']"
          >{{ displayPercentage }}%</span>
          from the previous period
        </div>
        <span
          v-else
          class="opacity-0"
        >No emission intensity change from the previous year to display</span>
      </div>
    </div>
    <!-- noEmissionIntensity -->
    <div
      v-else
      class="flex items-center gap-2"
    >
      <h1 class="text-3xl font-medium 2xl:text-5xl text-slate-900">
        {{ Math.floor(Math.random() * 100) }}
      </h1>
      <span class="text-sm 2xl:text-base text-[#707C8ECC] no-localize-translate">tCO<sub>2</sub>e per USD</span>
    </div>
    <div
      v-show="noEmissionIntensity"
      class="absolute inset-0 z-10 flex items-center bg-gray-100 cursor-pointer opacity-90"
      @click="handleClick"
    >
      <span class="ml-20 2xl:ml-24 text-slate-600">Click here to update revenue information to view the metric</span>
    </div>
    <svg
      class="absolute right-0 w-12 h-24 top-4"
      viewBox="0 0 65 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_440_582)">
        <path
          d="M108.333 113.75C102.12 91.975 97.5918 70.2704 97.4997 48.75H64.9997C64.9076 70.2704 60.3793 91.975 54.1663 113.75"
          stroke="#707C8E"
          stroke-opacity="0.2"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M62.292 70.4167H37.917C37.7816 84.565 33.0745 99.1033 27.0837 113.75"
          stroke="#707C8E"
          stroke-opacity="0.2"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M81.25 27.0833C80.0195 25.369 78.3902 23.98 76.5027 23.0363C74.6153 22.0925 72.5264 21.6225 70.4167 21.6667C68.3069 21.6225 66.2181 22.0925 64.3306 23.0363C62.4432 23.98 60.8138 25.369 59.5833 27.0833C58.3528 28.7977 56.7235 30.1867 54.836 31.1304C52.9486 32.0741 50.8598 32.5442 48.75 32.5C46.6402 32.5442 44.5514 32.0741 42.664 31.1304C40.7765 30.1867 39.1472 28.7977 37.9167 27.0833C36.6862 25.369 35.0568 23.98 33.1694 23.0363C31.2819 22.0925 29.1931 21.6225 27.0833 21.6667C24.9736 21.6225 22.8848 22.0925 20.9973 23.0363C19.1099 23.98 17.4805 25.369 16.25 27.0833"
          stroke="#218579"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M113.75 113.75H10.8333"
          stroke="#707C8E"
          stroke-opacity="0.2"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_440_582">
          <rect
            class="size-24"
            fill="white"
            transform="matrix(-1 0 0 1 130 0)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'EmissionIntensityCardNew',

  props: {
    intensity: {
      type: [Number, null],
      default: null,
    },
    intensityChange: {
      type: [Number, null],
      default: () => 0,
    },
    currency: {
      type: String,
      required: true,
    },
  },

  computed: {
    emissionsIntensity() {
      return typeof this.intensity === 'number' ? thousands(this.intensity, 2) : this.intensity
    },
    noEmissionIntensity() {
      return this.intensity === null
    },
    companyCurrency() {
      return this.currency
    },
    displayPercentage() {
      return `${this.previousYearIntensityChange !== 0 ? thousands(this.previousYearIntensityChange) : this.previousYearIntensityChange}`
    },
    previousYearIntensityChange() {
      return this.intensityChange
    },
  },
  methods: {
    handleClick() {
      if (this.intensity === null) {
        this.$router.push('/dashboard/ghg-overview/historical-data')
      }
    },
  },
}
</script>
